import { Component, input, output } from '@angular/core';
import { CopyQuoteSelectionsButtonComponent } from '@lx/quote-tool/lite/shared/ui/components';

@Component({
  standalone: true,
  selector: 'lx-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [CopyQuoteSelectionsButtonComponent],
})
export class LayoutComponent {
  title = input<string>();
  subtitle = input<string>();
  withSidebar = input(true);
  shareableDeeplink = input(false);
  valid = input(false);
  copied = input(false);

  copyRequested = output<void>();

  protected handleCopyRequested(): void {
    this.copyRequested.emit();
  }
}
